<ul
  [class]="
    cn(
      'hidden items-center lg:flex font-medium',
      isDark() ? 'gap-6 text-sm' : 'gap-5 text-[13px]'
    )
  "
>
  @for (item of items(); track item.labelKey) {
    @if (item.kind === 'link') {
      <li>
        @if (item.path && !item.disabled) {
          <a
            [routerLink]="item.path | localizedRouterLink"
            routerLinkActive="font-semibold"
            [routerLinkActiveOptions]="{ exact: item.path === '/' }"
            [class]="
              cn(
                'rounded-full px-1 py-0.5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2',
                isDark()
                  ? 'text-white/75 hover:text-primary-glow focus-visible:ring-offset-ink [&.font-semibold]:text-primary-glow'
                  : 'text-foreground/70 hover:text-primary focus-visible:ring-offset-background [&.font-semibold]:text-primary'
              )
            "
          >
            {{ item.labelKey | transloco }}
          </a>
        } @else {
          <span
            aria-disabled="true"
            [class]="
              cn(
                'cursor-not-allowed rounded-full px-1 py-0.5 opacity-50',
                isDark() ? 'text-white/60' : 'text-foreground/60'
              )
            "
          >
            {{ item.labelKey | transloco }}
          </span>
        }
      </li>
    } @else {
      <li class="relative">
        <button
          type="button"
          aria-haspopup="menu"
          [attr.aria-expanded]="openMenu() === item.labelKey"
          (click)="toggleMenu(item.labelKey)"
          (mouseenter)="openMenuOnHover(item.labelKey)"
          [class]="
            cn(
              'inline-flex items-center gap-1 rounded-full px-1 py-0.5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2',
              isDark()
                ? 'text-white/75 hover:text-primary-glow focus-visible:ring-offset-ink'
                : 'text-foreground/70 hover:text-primary focus-visible:ring-offset-background',
              openMenu() === item.labelKey && (isDark() ? 'text-primary-glow' : 'text-primary')
            )
          "
        >
          {{ item.labelKey | transloco }}
          <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            [class]="cn('h-3.5 w-3.5 transition-transform', openMenu() === item.labelKey && 'rotate-180')"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>

        @if (openMenu() === item.labelKey) {
          <div
            role="menu"
            (mouseleave)="closeMenus()"
            [class]="
              cn(
                'ios-menu absolute left-0 top-full z-50 mt-2 w-60 origin-top-left',
                isDark() ? 'ios-menu--dark' : 'ios-menu--light'
              )
            "
          >
            @for (sub of item.items; track sub.labelKey) {
              @if (sub.path && !sub.disabled) {
                <a
                  [routerLink]="sub.path | localizedRouterLink"
                  role="menuitem"
                  (click)="closeMenus()"
                  class="ios-menu-item"
                >
                  <span class="truncate">{{ sub.labelKey | transloco }}</span>
                </a>
              } @else {
                <span
                  role="menuitem"
                  aria-disabled="true"
                  class="ios-menu-item cursor-not-allowed opacity-50"
                >
                  <span class="truncate">{{ sub.labelKey | transloco }}</span>
                </span>
              }
            }
          </div>
        }
      </li>
    }
  }
</ul>
